export default "__VITE_ASSET__C8pv1Xlf__"